Vue.component('check-sales', {
    methods: {
        statusChange (event, sale) {
            if (sale && event.target.value.toLowerCase() !== 'converted') {
                $('#check-sales-view').modal('show');
            }
        }
    }
});